export default __webpack_public_path__ + "static/media/LENS_CULINARIS_GDM_5.4d98894e.jpg";